import { render, staticRenderFns } from "./PromoSlider.vue?vue&type=template&id=1d4cefec&"
import script from "./PromoSlider.vue?vue&type=script&lang=js&"
export * from "./PromoSlider.vue?vue&type=script&lang=js&"
import style0 from "./PromoSlider.vue?vue&type=style&index=0&id=1d4cefec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports